import React from 'react';
import styled from 'styled-components';

type propTypes = {
  children: string
  type?: string;
  variant?: string;
  onClick?: (event: any) => void;
  size?: string;
  disabled?: boolean;
  isIconHidden?: boolean;
  icon?: string
};

const Button = (props: propTypes) => {

  const { children, type, variant, onClick, size, disabled, isIconHidden, icon } = props
  let bClasses: string;
  // let bIcon: string;
  let bTitle: string;

  const renderIcon = (tIcon: string | undefined) => {
    if (!(icon || tIcon) || isIconHidden) {
      return null;
    }
    return <i className={icon} />;
  }

  switch (type) {
    case 'add':
    case 'primary':
      bClasses = variant === undefined ? `btn-primary btn-${size}` : `${variant} btn-${size}`;
      // bIcon = 'fa fa-plus';
      bTitle = 'Add';
      break;

    case 'success':
      bClasses = variant === undefined ? `btn-success btn-${size}` : `${variant} btn-${size}`;
      // bIcon = 'fa fa-check';
      bTitle = 'Success';
      break;

    case 'remove':
    case 'danger':
      bClasses = variant === undefined ? `btn-danger btn-${size}` : `${variant} btn-${size}`;
      // bIcon = 'fa fa-minus';
      bTitle = 'Remove';
      break;

    case 'info':
      bClasses = variant === undefined ? `btn-info btn-${size}` : `${variant} btn-${size}`;
      // bIcon = 'fa fa-info-circle';
      bTitle = 'Info';
      break;

    case 'warning':
      bClasses = variant === undefined ? `btn-warning btn-${size}` : `${variant} btn-${size}`;
      // bIcon = 'fa fa-exclamation-circle';
      bTitle = 'Warning';
      break;

    case 'default':
    default:
      bClasses = variant === undefined ? `btn-primary btn-${size}` : `${variant} btn-${size}`;
      // bIcon = '';
      bTitle = 'Default';
      break;
  }
  return (
    <ButtonWithStyled>
      <button className={`btn ${bClasses}`} disabled={disabled} onClick={onClick}>
        {renderIcon(icon)} {children === undefined ? bTitle : children}
      </button>
    </ButtonWithStyled>
  )
}

const ButtonWithStyled = styled.div`
`;

Button.defaultProps = {
  size: 'md',
  disabled: false,
  isIconHidden: false,
  icon: null,
};

export default Button;